import React from "react";
import { IControlStyles, useControlStyles } from "../.";
import { ComponentProps, ControlInput, ControlTemplateProps } from "../misc/controlInput";

export interface ControlRangeProps extends ControlTemplateProps {
    
}

export const ControlRange: React.FC<ControlRangeProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ??  useControlStyles();
    
    return (
        <ControlInput type="range" {...ComponentProps(props)} style={{ ...styles.range ?? styles.input, ...props.style }} />        
    );
};